import { useCallback } from "react";
import { PaginationConfig } from "antd/lib/pagination";
import { removeNullableEntries } from "util/object";

import { useLocationState } from "hooks/useLocationState";

export const defaultPageSizeKey = "defaultPageSize";

type LocationState = {
  page?: number;
};

export const usePagination = () => {
  const [locationState, setLocationState] = useLocationState<LocationState>("pagination", {});

  const defaultCurrent = locationState.page;
  const defaultPageSize = Number(localStorage.getItem(defaultPageSizeKey)) || undefined;

  const pagination = removeNullableEntries({
    defaultPageSize,
    defaultCurrent,
    showSizeChanger: true,
  });

  const setPagination = useCallback(
    ({ pageSize, current }: PaginationConfig) => {
      if (pageSize) {
        localStorage.setItem(defaultPageSizeKey, String(pageSize));
      }

      if (current) {
        setLocationState({ page: current });
      }
    },
    [setLocationState],
  );

  return [pagination, setPagination] as const;
};
